"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILocationStatusID = exports.IAgeRestrictionType = exports.IHomeTypeID = exports.ISellerTypeID = exports.IModelTypeID = exports.IEntityType = exports.IListingTypeID = exports.IEnvironment = void 0;
var IEnvironment;
(function (IEnvironment) {
    IEnvironment["Production"] = "PRODUCTION";
    IEnvironment["Staging"] = "STAGING";
    IEnvironment["Development"] = "DEVELOPMENT";
})(IEnvironment = exports.IEnvironment || (exports.IEnvironment = {}));
var IListingTypeID;
(function (IListingTypeID) {
    IListingTypeID[IListingTypeID["ForSale"] = 1] = "ForSale";
    IListingTypeID[IListingTypeID["ForRent"] = 2] = "ForRent";
    IListingTypeID[IListingTypeID["ForRentAndToOwn"] = 3] = "ForRentAndToOwn";
    IListingTypeID[IListingTypeID["ForRentOrForSale"] = 4] = "ForRentOrForSale";
})(IListingTypeID = exports.IListingTypeID || (exports.IListingTypeID = {}));
var IEntityType;
(function (IEntityType) {
    IEntityType[IEntityType["Home"] = 1] = "Home";
    IEntityType[IEntityType["Community"] = 2] = "Community";
    IEntityType[IEntityType["Dealer"] = 3] = "Dealer";
})(IEntityType = exports.IEntityType || (exports.IEntityType = {}));
var IModelTypeID;
(function (IModelTypeID) {
    IModelTypeID[IModelTypeID["SingleWide"] = 1] = "SingleWide";
    IModelTypeID[IModelTypeID["DoubleWide"] = 2] = "DoubleWide";
    IModelTypeID[IModelTypeID["TripleWide"] = 3] = "TripleWide";
    IModelTypeID[IModelTypeID["ParkModel"] = 4] = "ParkModel";
    IModelTypeID[IModelTypeID["Unspecified"] = 5] = "Unspecified";
})(IModelTypeID = exports.IModelTypeID || (exports.IModelTypeID = {}));
var ISellerTypeID;
(function (ISellerTypeID) {
    ISellerTypeID[ISellerTypeID["Owner"] = 1] = "Owner";
    ISellerTypeID[ISellerTypeID["Agent"] = 2] = "Agent";
    ISellerTypeID[ISellerTypeID["Dealer"] = 3] = "Dealer";
    ISellerTypeID[ISellerTypeID["Repo"] = 4] = "Repo";
})(ISellerTypeID = exports.ISellerTypeID || (exports.ISellerTypeID = {}));
var IHomeTypeID;
(function (IHomeTypeID) {
    IHomeTypeID[IHomeTypeID["Community"] = 2] = "Community";
    IHomeTypeID[IHomeTypeID["MobileHome"] = 1] = "MobileHome";
})(IHomeTypeID = exports.IHomeTypeID || (exports.IHomeTypeID = {}));
var IAgeRestrictionType;
(function (IAgeRestrictionType) {
    IAgeRestrictionType[IAgeRestrictionType["FiftyFivePlus"] = 2] = "FiftyFivePlus";
    IAgeRestrictionType[IAgeRestrictionType["AllAges"] = 1] = "AllAges";
})(IAgeRestrictionType = exports.IAgeRestrictionType || (exports.IAgeRestrictionType = {}));
var ILocationStatusID;
(function (ILocationStatusID) {
    ILocationStatusID[ILocationStatusID["InACommunity"] = 1] = "InACommunity";
    ILocationStatusID[ILocationStatusID["OwnerOwnedLand"] = 2] = "OwnerOwnedLand";
    ILocationStatusID[ILocationStatusID["LeasedRentedLand"] = 3] = "LeasedRentedLand";
    ILocationStatusID[ILocationStatusID["NotInACommunity"] = 4] = "NotInACommunity";
    ILocationStatusID[ILocationStatusID["OnDealerLot"] = 5] = "OnDealerLot";
})(ILocationStatusID = exports.ILocationStatusID || (exports.ILocationStatusID = {}));
